import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { securitySwitchOrganizationPostAsyncSlice } from './post';

export const securitySwitchOrganizationReducers = combineReducers({
	post: securitySwitchOrganizationPostAsyncSlice.asyncReducers
});

export const securitySwitchOrganizationWatchers = combineAllWatchers([
	securitySwitchOrganizationPostAsyncSlice.asyncWatchers
]);
